window.PesquisarCotacoesPerdidasController = ControllerBase.extend({
    name: 'PesquisarCotacoesPerdidasController',
    framework: 'knockout',
    region: '#pesquisa-cotacoes-perdidas-region',
    tamanhoPagina: 10,
    ajax: function () {

        var filtros = this.toJS(this.newModel());

        return {
            url: '/CotacaoPerdida/_Pesquisar',
            type: 'post',
            contentType: "application/json",
            data: global.toJSONString({ filtros: filtros })
        };
    },
    newModel: function() {
        return {
            Produtos: [],
            CodigoCliente: null,
            NomeCliente: null,
            ApenasCotacaoPerdidaOrcamento: this.orcamento && this.orcamento.get('IdentificadorOrcamento') != undefined,
            IdentificadorOrcamento: this.orcamento ? this.orcamento.get('IdentificadorOrcamento') : null,
            NumeroPagina: 1,
            TamanhoPagina: this.tamanhoPagina
        };
    },
    antesBinding: function () {

        if (!this.model.Entities) {
            this.appendToModel({ name: 'Entities', value: [] });
        }

        if (!this.model.RowsCount) {
            this.appendToModel({ name: 'RowsCount', value: null });
        }

        this.appendToModel({ name: 'PesquisarApenasCotacaoPerdidaOrcamento', value: this.orcamento != undefined })
        this.appendToModel({ name: 'Produtos', value: [] });
        this.appendToModel({ name: 'CodigoCliente', value: null });
        this.appendToModel({ name: 'NomeCliente', value: null });
        this.appendToModel({ name: 'ApenasCotacaoPerdidaOrcamento', value: this.orcamento && this.orcamento.get('IdentificadorOrcamento') != undefined });
        this.appendToModel({ name: 'IdentificadorOrcamento', value: this.orcamento ? this.orcamento.get('IdentificadorOrcamento') : null });
        this.model.ApenasCotacaoPerdidaOrcamento.subscribe($.proxy(this.limpar, this, 'ApenasCotacaoPerdidaOrcamento'));
        this.model.CodigoCliente.subscribe($.proxy(this.limpar, this, 'Cliente'));
        this.model.Produtos.subscribe($.proxy(this.limpar, this, 'Produtos'));
    },
    aposBinding: function () {
        this.atualizarPaginador(this.toJS(this.model));
        $("input").on('focus', function () { $(this).select(); });
        $("textarea").on('focus', function () { $(this).select(); });
    },
    limpar: function (property, value) {
        if (this.executarLimpar != undefined && this.executarLimpar == false) {
            return;
        }
        this.executarLimpar = false;
        this.model.Entities.removeAll();
        this.model.RowsCount(undefined);
        if (property == 'ApenasCotacaoPerdidaOrcamento') {
            this.model.Produtos.removeAll();
            this.model.CodigoCliente(undefined);
            this.model.NomeCliente(undefined);
        }

        if (this.paginador) {
            this.paginador.limpar();
        }
        this.executarLimpar = true;

    },
    atualizarPaginador: function (data) {

        this.paginador = new Paginator({
            container: "#page-cotacoes-perdidas",
            data: data,
            pageClickCallback: $.proxy(this.paginar, this)
        });

    },
    paginar: function (e) {
        this.pesquisar(null, null, e.page);
    },
    pesquisar: function (mode, e, pagina) {

        pagina = pagina || 1;

        var codigosProdutos = [];

        if (this.model.Produtos() && this.model.Produtos().length > 0) {
            $.each(this.model.Produtos(),
                function () {
                    codigosProdutos.push(this.Codigo);
                });
        }

        var filtros = {
            CodigoCliente: this.model.CodigoCliente(),
            CodigosProdutos: codigosProdutos,
            IdentificadorOrcamento: this.model.ApenasCotacaoPerdidaOrcamento() ? this.model.IdentificadorOrcamento() : null,
            NumeroPagina: pagina,
            TamanhoPagina: this.tamanhoPagina
        };

        var self = this;

        global.ajax({
            url: '/CotacaoPerdida/Listar',
            type: 'post',
            contentType: 'application/json',
            data: global.toJSONString({ filtros: filtros }),
            success: function (data) {

                if (!data || data.HasErrors) {
                    return;
                }

                var m = ko.mapping.fromJS(data.Entities);
                self.model.Entities(m());
                self.model.RowsCount(data.RowsCount);
                self.atualizarPaginador(data);
            }
        });
    },
    pesquisarProduto: function () {
        this.pesquisarProdutosController = this.showView({
            region: {
                name: "pesquisarProdutosPesquisaCotacoesPerdidasRegion",
                selector: "#pesquisar-produtos-pesquisa-cotacoes-perdidas-region"
            },
            controller: {
                type: PesquisarProdutosController,
                args: {
                    model: this.orcamento,
                    orcamento: this.orcamento,
                    adicionarProdutosCallback: $.proxy(this.adicionarProdutos, this),
                    esconderForaEstoque: true,
                    permitirPesquisarHistorico: false,
                    cotacaoPerdida: true
                }
            }

        });
    },
    adicionarProdutos: function (produtos) {
        if (!produtos) {
            return;
        }

        this.pesquisarProdutosController.hide();
        this.show();

        var self = this;

        $.each(produtos,
            function (i, e) {
                if (!_.find(self.model.Produtos(), function (o) { return o.Codigo === e.Codigo; })) {
                    self.model.Produtos.push(this);
                }
            });
    },

    removerProduto: function (produto) {
        if (!produto) {
            return;
        }

        this.model.Produtos.remove(produto);
    },
    pesquisarCliente: function () {
        this.pesquisarClientesController = this.showView({
            region: {
                name: "pesquisarClientesPesquisaCotacoesPerdidasRegion",
                selector: "#pesquisar-clientes-pesquisa-cotacoes-perdidas-region"
            },
            controller: {
                type: PesquisarClientesController,
                args: {
                    clienteSelecionadoCallbackView: $.proxy(this.clienteSelecionado, this)
                }
            }
        });
    },
    clienteSelecionado: function (cliente) {
        if (!cliente) {
            return;
        }
        this.model.CodigoCliente(cliente.get("Codigo"));
        this.model.NomeCliente(cliente.get("Nome"));
        this.pesquisarClientesController.hide();
        this.show();
    },
    removerCliente: function () {
        this.model.CodigoCliente(undefined);
        this.model.NomeCliente(undefined);
    }
});